export type Holiday = {
  status: string;
  date: string | Date;
};

interface Props {
  holiday: Holiday;
}

export const HolidayEvent = ({ holiday }: Props) => {
  return (
    <div className="flex items-center justify-between px-3 py-2 bg-[#800080]">
      <div>{holiday?.status}</div>
    </div>
  );
};
